import { useContext } from "react";
import ContactContext, { type ContactContextType } from "../context/ContactProvider";

const useContact = (): ContactContextType => {
    return useContext(ContactContext);
};

export default useContact;